import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appScrollSpy]',
  standalone: true,
})
export class ScrollSpyDirective implements AfterViewInit {
  @Output() activeChild = new EventEmitter<string>(); // Emits active child ID
  private scrollTimeout: any;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {}

  @HostListener('scroll', ['$event'])
  onScroll() {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => this.snapToNearestChild(), 200);
  }

  private snapToNearestChild() {
    const parent = this.el.nativeElement;
    const children = Array.from(parent.children) as HTMLElement[];

    let minDistance = Infinity;
    let closestChild: HTMLElement | null = null;

    children.forEach((child) => {
      const distance = Math.abs(child.offsetLeft - parent.scrollLeft);
      if (distance < minDistance) {
        minDistance = distance;
        closestChild = child;
      }
    });

    if (closestChild) {
      // Scroll smoothly to the nearest child
      parent.scrollTo({
        left: closestChild.offsetLeft,
        behavior: 'smooth',
      });

      // ✅ Emit only one final child ID
      this.activeChild.emit(closestChild.id);
    }
  }

  /*scrollToChild(childId: string) {
    const childElement = document.getElementById(childId);
    if (childElement) {
      childElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }*/
}
